import { render, staticRenderFns } from "./DSPopups.vue?vue&type=template&id=dddf87ca&"
import script from "./DSPopups.vue?vue&type=script&lang=js&"
export * from "./DSPopups.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports